import PropTypes from "prop-types";
import Webcam from "react-webcam";
import { titleOptionsNew } from "../../../constants";
import Input from "../../commonComponents/Input";
import Select from "../../commonComponents/Select";
import "../../../assets/scss/modules/_layoutGlobal.scss";
import "../../../assets/scss/personal_detail.scss";
import "../../../assets/scss/components/_formsGlobal.scss";
import "../../../assets/scss/components/_buttonsGlobal.scss";
import "../../../assets/scss/base/themecomponents/_resetGlobal.scss";
import "../../../assets/font_icons/style.scss";
import "../../../assets/scss/components/_modalGlobal.scss";
import Label from "../../commonComponents/Label";
import RadioBtn from "../../commonComponents/RadioBtn";
import StateJson from "../../../constants/States.json";
import ProfileUploadModal from "../../commonComponents/ProfileUploadModal";
import { useState } from "react";
import Form from "../../common/Form";
import ImageDisplayModal from "../../commonComponents/ImageDisplayModal";
import { Link } from "react-router-dom";
import disable_link from "../../../svg/disable-link.svg";
import active_link from "../../../svg/active-link.svg";

const About = (props) => {
  const {
    profileDetails,
    setProfileDetails,
    handleChangeRadioButton,
    handleChange,
    commonAddFields,
    setCommonAddFields,
    profile,
    hiddenFileInput,
    handleUploadImage,
    openTab,
    phone,
    handleSelectChange,
    webcamImage,
    setWebcamImage,
    openWebcam,
    setOpenWebcam,
    uploadedImage,
    setUploadedImage,
    handleSubmitAboutTab,
    imageDisplayModalOpen,
    setImageDisplayModalOpen,
    handleWebcam,
    webcamRef,
    capture,
    handleImageModalClose,
    handleImageSubmit,
    openImageUpload,
    setOpenImageUpload,
    UploadMedia,
  } = props;

  function onRetake() {
    setWebcamImage("")
  }
  //new code

  const render = () => {
    if (webcamImage) {
      return (
        <span className="flex-fill text-center">
          <img
            src={webcamImage}
            alt="invalid img"
            className="user-img"
            onClick={() => handleWebcam()}
          />
        </span>
      );
    }
    return (
      <Webcam
        onClick={() => capture()}
        audio={false}
        ref={webcamRef}
        width="50%"
        screenshotFormat="image/jpeg"
      />
    );
  };
  const renderImage = () => {
    if (uploadedImage) {
      return ''
    }
    return (
      <Link
        className=""
        onClick={() => setOpenWebcam(true)}
      >
        <b className="icon-camera"></b>
        Take Picture
      </Link>
    )
  }

  const AddWebsiteField = (e, val, ind) => {
    if (ind === 0) {
      let uuid = "personalWebsites" + Math.random().toString(16).slice(2);
      setCommonAddFields({
        ...commonAddFields,
        personalWebsites: [
          ...commonAddFields.personalWebsites,
          { id: uuid, value: "" },
        ],
      });
    } else {
      const cloneLan = [...commonAddFields.personalWebsites];
      const remove = cloneLan.filter((v, i) => v.id != val.id);
      setCommonAddFields({ ...commonAddFields, personalWebsites: remove });
    }
  };
  const [modalOpen, setModalOpen] = useState(false)
  const removeLanguage = (index) => {
    const cloneLang = profileDetails.languagesKnown.filter((_val, ind) => ind !== index)
    setProfileDetails({ ...profileDetails, languagesKnown: cloneLang })
  }

  const handleClose = () => {
    setModalOpen(false)
  }
  const uploadImage = () => {
    hiddenFileInput.current.click()
  }

  const wordsLeft = () => {
    return (500 - (profileDetails?.professionalSummary ? profileDetails?.professionalSummary?.trim()?.split(" ")?.length : 0 ))
  }

  return (
      <div className="boxCover">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <div class="boxTitle">
          <h1 class="titleText">Tell Us About Yourself</h1>
          <p>Help people get to know you at a glance </p>
        </div>
        <div className="profilePic">
          <div
            className={`picCircle ${profile && "noBg"}`}
          // data-bs-toggle="modal"
          // data-bs-target="#uploadPicModal"
          >
            {profile ? (
              <img src={profile} className="" alt="" />
            ) : (
              <b class="icon-camera" onClick={() =>
                setOpenImageUpload(true)
              }></b>
            )}
          </div>
          <div>
            <p
              onClick={() =>
                setOpenImageUpload(true)
              }
              className="mb-1 cursor-pointer"
              // data-bs-toggle="modal"
              // data-bs-target="#uploadPicModal"
            >
              {'Upload Profile Picture'} <small className="labelBadge">Mandatory</small>
            </p>
            <span className="error-field">{props?.errors?.profile}</span>
            <span>
              A professional photo will help build confidence with your clients
            </span>
          </div>
        </div>

        <div class="fieldSet  border-0">
          <ul>
            <li>
              <div class="fieldName mb-3">
                <div className={props?.errors?.title ? "fieldWrap error" : "fieldWrap"}>
                  <Label className="labelForm">Title <span className="astric">*</span></Label>
                  <Select
                    className={"fieldForm"}
                    handleChange={handleSelectChange}
                    options={titleOptionsNew?.map(val => val?.key)}
                    optionValues={titleOptionsNew?.map(val => val?.value)}
                    name={"title"}
                    label="Title"
                    labelClass={profileDetails?.title ? "" : "hidden"}
                    selectedValue={profileDetails?.title}
                    />
                    {/* <span className="error-field">{props?.errors?.title}</span> */}
                </div>
                <div class="fieldWrap">
                  <Label className="labelForm">
                    Full Name<small className="labelBadge">Mandatory</small>
                  </Label>
                  <div>
                    <Input
                      className={"fieldForm"}
                      type="text"
                      name="fullname"
                      placeholder="Full Name"
                      value={profileDetails?.fullname}
                      handleChange={(e) => handleChange(e)}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
            </li>
            <li>

              <div class="fieldWrap mb-3">
                <Label className="labelForm">
                  Company Name <small className="otherBadge">Optional</small>
                </Label>
                <div class="fieldCover">
                  <b class="icon-building"></b>
                  <Input
                    className={"fieldForm"}
                    type="text"
                    name="organizationName"
                    placeholder="Organisation name"
                    value={profileDetails?.organizationName}
                    handleChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
            </li>
            <li>
              <div class="fieldWrap mb-3">
                {
                  profileDetails?.email ? (
                    <>
                    <Label className="labelForm" labelText="Email ID" />
                <div class="fieldCover">
                  <b class="icon-email"></b>
                  <Input
                    className={"fieldForm"}
                    type="text"
                    name="email"
                    placeholder="Email ID"
                    value={profileDetails?.email}
                    handleChange={(e) => handleChange(e)}
                    readOnly={true}
                  />
                </div>
                </>
                  ) : (
                    <>
                    <Label className="labelForm">
                      Email ID<small className="labelBadge">Mandatory</small>
                    </Label>
                <div class="fieldCover">
                  <b class="icon-email"></b>
                  <Input
                    className={props?.errors?.email ? "telephone-border" : "fieldForm"}
                    type="text"
                    name="email"
                    placeholder="Email ID"
                    value={profileDetails?.email}
                    handleChange={(e) => handleChange(e)}
                  />
                  <span className="error-field">{props?.errors?.email}</span>
                </div>
                </>
                  )
                }
              </div>
            </li>
            <li>
              <div class="fieldWrap mb-3">
                <Label className="labelForm">
                  Mobile Number <small className="labelBadge">Mandatory</small>
                </Label>
                <div class="fieldCover">
                  <b class="icon-call"></b>
                  <Input
                    readOnly={!!phone}
                    placeholder="xxxxxxxxxx"
                    type="tel"
                    value={profileDetails?.phoneNumber}
                    className={props?.errors?.phoneNumber ? "telephone-border" : "fieldForm"}
                    name="phoneNumber"
                    handleChange={(e) => handleChange(e)}
                  />
                  <span className="error-field">{props?.errors?.phoneNumber}</span>
                </div>
              </div>
            </li>

            <li class="fullWidth pt-3">
              <div class="fieldWrap mb-3">
                <div className="d-flex align-items-center">
                <Label className="labelForm p-0 m-0 pe-1" labelText="Gender" />
                 <small className="otherBadge">Private</small>
                </div>
               
                <div>
                  {/* <input type="file" hidden ref={hiddenFileInput} onChange={() => handleUploadImage()} /> */}
                  <div class="d-inline-flex mx-4 ms-0">
                    <Label className="styledRadio">
                      <RadioBtn
                        type="radio"
                        name="gender"
                        id="Male"
                        checked={profileDetails.gender === "Male"}
                        handleChange={(e) => handleChangeRadioButton(e)}
                        radioLabel="Male"
                      />
                    </Label>
                  </div>
                  <div class="d-inline-flex mx-4 ms-0">
                    <Label className="styledRadio">
                      <RadioBtn
                        type="radio"
                        name="gender"
                        id="Female"
                        checked={profileDetails.gender === "Female"}
                        handleChange={(e) => handleChangeRadioButton(e)}
                        radioLabel="Female"
                      />
                    </Label>
                  </div>
                  <div class="d-inline-flex mx-4 ms-0">
                    <Label className="styledRadio">
                      <RadioBtn
                        type="radio"
                        name="gender"
                        id="Gender Fluid"
                        checked={profileDetails.gender === "Gender Fluid"}
                        handleChange={(e) => handleChangeRadioButton(e)}
                        radioLabel="Gender Fluid"
                      />
                    </Label>
                  </div>
                  <div class="d-inline-flex mx-4 ms-0">
                    <Label className="styledRadio">
                      <RadioBtn
                        type="radio"
                        name="gender"
                        id="Others"
                        checked={profileDetails.gender === "Others"}
                        handleChange={(e) => handleChangeRadioButton(e)}
                        radioLabel="Others"
                      />
                    </Label>
                  </div>
                </div>
              </div>
            </li>
            <li class="fullWidth pt-3">
              <div class="fieldWrap mb-1">
                <h3 class="labelHeading mb-1">
                  Professional Summary <span>(word limit - 500 words)</span>
                </h3>
                <small class="fieldNote">
                  Describe your top skills, experiences and interests. This is one
                  of the first things clients will see on your profile
                </small>
                <div>
                  <textarea
                    class="fieldForm"
                    placeholder="Tell us about yourself"
                    name="professionalSummary"
                    value={profileDetails?.professionalSummary}
                    onChange={(e) => handleChange(e)}
                    // maxlength="500"
                  ></textarea>
                  <span className="word_remaing">( {wordsLeft()} words left )</span>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="fieldSet ">
          <h3 class="labelHeading mb-4 d-flex align-items-center">Mailing Address <small className="otherBadge">Private</small></h3>
          <ul>
            <li>
              <div class="fieldWrap mb-4">
                <Label className="labelForm" labelText="Apartment/House Number" />
                <Input
                  className={"fieldForm"}
                  type="text"
                  name="apartment_house_no"
                  placeholder="Apartment/House Number"
                  value={profileDetails?.apartment_house_no}
                  handleChange={(e) => handleChange(e)}
                />
              </div>
            </li>

            <li>
              <div class="fieldWrap mb-4">
                <Label className="labelForm" labelText="State" />
                <Select
                  className="fieldForm"
                  options={Object.keys(StateJson)?.sort()}
                  name="state"
                  handleChange={handleSelectChange}
                  selectedValue={profileDetails?.state}
                  placeholder='Select State'
                />
              </div>
            </li>

            <li>
              <div class="fieldWrap mb-3">
                <Label className="labelForm" labelText="City" />
                <Select
                  className="fieldForm"
                  options={StateJson?.[profileDetails?.state]?.sort()}
                  name="city"
                  handleChange={handleSelectChange}
                  selectedValue={profileDetails?.city}
                  disabled={(profileDetails?.state ? false : true)}
                />
              </div>
            </li>

            <li>
              <div class="fieldWrap mb-3">
                <Label className="labelForm" labelText="Pin Code" />
                <Input
                  className='fieldForm'
                  placeholder="Pin Code"
                  name="pincode"
                  type="pin"
                  value={profileDetails?.pincode}
                  handleChange={(e) => handleChange(e)}
                />
              </div>
            </li>
          </ul>
        </div>

        <div class="fieldSet">
          <div class="fieldRow">
            <div class="fieldCol">
              <div class="fieldWrap">
                <Label className="labelForm" labelText="Professional Website" />
                {commonAddFields?.personalWebsites?.map((val, index) => {
                  return (<div key={val.id}>
                    <div key={val.id} class="fieldCover">
                      <img src={val?.value ? active_link : disable_link} className="pre-icon" alt="link" />
                      <Input
                        type="text"
                        className={"fieldForm"}
                        name={val.id}
                        handleChange={(e) => handleChange(e, "personalWebsites")}
                        value={val.value}
                      />
                      {val?.error && <div className="label-error">{val.error}</div>}
                    </div>
                    <div class="fieldMore">
                      <a onClick={(e) => AddWebsiteField(e, val, index)}>{index === 0 ? "+ Add Another" : "- Remove"}</a>
                    </div>
                  </div>)
                })}
              </div>

            </div>
            <div class="fieldCol multiselect-skills">
              <div class="fieldWrap">
                <Label className="labelForm" labelText="Known Languages" />
                <Select
                  className="fieldForm"
                  options={["Hindi", "English", "Tamil", "Marathi", "Punjabi"]}
                  name="languagesKnown"
                  handleChange={handleSelectChange}
                  placeholder='Select'
                  selectedValue={""}
                />
              </div>
              <div class="tagWrap mt-3">
                {profileDetails?.languagesKnown?.[0] === "" ? null : profileDetails?.languagesKnown?.map((val, ind) => {
                  return <div key={ind} class="tagBox">{val} <a onClick={() => removeLanguage(ind)}><b class="icon-cross"></b></a></div>
                })}
              </div>
            </div>
            <ProfileUploadModal
              show={openImageUpload}
              webcamImage={webcamImage}
              isPersonal={true}
              onImgCapture={capture}
              onSubmit={handleImageSubmit}
              onRetake={onRetake}
              informationText="Please choose from the options below"
              modalHeading={'Upload Profile Picture'}
              retakebuttonTitle={
                uploadedImage ? "Select a different image" : "Retake"
              }
              submitButtonTitle="Upload"
              disabled={false}
              handleClose={() => handleImageModalClose()}
              openWebcam={openWebcam}
              uploadedImage={uploadedImage ? true : false}
              SelectdifferentImage={() => hiddenFileInput.current.click()}
            >
              <>
                <div className="profileModal-opt upload-area align-items-center justify-content-center">
                  {!openWebcam ? (
                    renderImage()
                  ) : (
                    render()
                  )}
                  {!openWebcam && (
                    <>
                      <Link className={uploadedImage ? "noBg" : ""} onClick={() =>
                        uploadImage()
                      }>
                        <div
                          className="profile-upload"

                        >
                          {uploadedImage ? (
                            <img src={uploadedImage} alt="" className="user-img" />
                          ) : (
                            <span
                              // to="#"
                              className="d-flex align-itmes-center"
                            >
                              <b className="icon-upload"></b>
                              {/* <img src={upload} className="me-2" alt="upload" /> */}
                              Choose File
                            </span>
                          )}
                        </div>

                      </Link>
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        ref={hiddenFileInput}
                        onChange={handleUploadImage}
                      />
                    </>
                  )}
                </div>
                {/* <div className="label-error text-center">{formError?.profile}</div> */}
              </>
            </ProfileUploadModal>
            {/* <ProfileUploadModal uploadImage={uploadImage} show={modalOpen} handleClose={handleClose} openWebcam={openWebcam}/>
            <ImageDisplayModal show={imageDisplayModalOpen} /> */}
          </div>
        </div>
      </div>
  );
};
About.propTypes = {
  profileDetails: PropTypes.shape({
    fullname: PropTypes.string,
    personalWebsite: PropTypes.string,
    languagesKnown: PropTypes.array,
    city: PropTypes.string,
    primaryEmail: PropTypes.string,
    secondaryEmail: PropTypes.string,
    countryCode: PropTypes.string,
    phoneNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    gender: PropTypes.string,
    professionalSummary: PropTypes.string,
  }),
  handleChangeRadioButton: PropTypes.func,
  openTab: PropTypes.array,
  handleChange: PropTypes.func,
  commonAddFields: PropTypes.shape({
    languagesKnown: PropTypes.array,
    personalWebsite: PropTypes.array,
  }).isRequired,
  setCommonAddFields: PropTypes.func,
  hiddenFileInput: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  profile: PropTypes.string,
  handleUploadImage: PropTypes.func,
  phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  webcamImage: PropTypes.string,
  setWebcamImage: PropTypes.func,
  openWebcam: PropTypes.bool,
  setOpenWebcam: PropTypes.func,
  uploadedImage: PropTypes.string,
  setUploadedImage: PropTypes.func,
  handleSubmitAboutTab: PropTypes.func,
  imageDisplayModalOpen: PropTypes.bool,
  setImageDisplayModalOpen: PropTypes.func,
  UploadMedia: PropTypes.func,
};

About.defaultProps = {
  handleChangeRadioButton: () => null,
  handleChange: () => null,
  profileDetails: {professionalPresence:[{}]},
  openTab: [],
  languagesKnown: [],
  personalWebsite: [],
  setLanguages: () => null,
  personalWebsites: () => null,
  profile: "",
  handleUploadImage: () => null,
  phone: "",
  webcamImage: '',
  setWebcamImage: () => null,
  openWebcam: false,
  setOpenWebcam: () => null,
  uploadedImage: '',
  setUploadedImage: () => null,
  handleSubmitAboutTab: () => null,
  imageDisplayModalOpen: false,
  setImageDisplayModalOpen: () => null,
  UploadMedia: () => null
};

export default About;
